import { Box, TextField, useTheme } from "@mui/material";
import moment from "moment";
import { useEffect, useImperativeHandle, useState, useRef, forwardRef } from "react";
import CustomDatePicker from "../utilities/CustomDatePicker";
import jwtDecode from "jwt-decode";

export const DateFromEditorComponent = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const theme = useTheme();
    const [validUntil, setValidUntil] = useState(props.value || null);
    const [maxDate, setMaxDate] = useState(null);
      const token =
        localStorage &&
        localStorage.getItem("token") &&
        jwtDecode(localStorage.getItem("token"));
         const hasSupperUser = [
    "ROLE_ADMIN",
    "ROLE_MD",
    "ROLE_SOPDIR",
  ].some((role) => {
    if (token) {
      return token.scope.includes(role);
    }
  });
    const handleValidUntilChange = (newValue) => {
        setValidUntil(newValue);
        const rowData = props.node;
        rowData.setDataValue('validFrom', moment(newValue).format('YYYY-MM-DD'))
    };
    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (validUntil !== null) {
                    return moment(validUntil).format('YYYY-MM-DD');

                }
            },
            focusIn() {
                var eInput = refDatePicker.current;
                // if (eInput) {
                eInput?.focus();
                eInput?.select();
                // }
            },
            getFromDate() {
                return moment(validUntil).format('YYYY-MM-DD');
            },
        };
    });
    useEffect(() => {
        // get ref from React component
        window.setTimeout(() => {
            const eInput = refDatePicker.current;
            // if(eInput){
            eInput?.focus();
            // }
        });

        props.api?.getCellEditorInstances().map((editor) => {
            if (editor?.getToDate) {
                setMaxDate(editor.getToDate());

            }
        })
    }, []);

    const handleFocusValidUntil = () => {
        props.api?.getCellEditorInstances().map((editor) => {
            if (editor?.getToDate) {
                setMaxDate(editor.getToDate());

            }
        })
    }


    return (

        <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'stretch' }}>
            <CustomDatePicker
                format={'dd-MM-yyyy'}
                name={'validUntil'}
                value={validUntil}
                minDate={
            (!hasSupperUser &&(props.node?.data?.enablePromoDisc || props.node?.data?.enableVendorPromoDisc||props.node?.data?.approvalStatus==="NEW"))
                ? new Date()
                : null
        }
                maxDate={maxDate && new Date(maxDate)}
                sx={{ width: '100%', height: '100%', backgroundColor: theme.palette.background.paper }}
                handleChange={handleValidUntilChange}
                onOpen={handleFocusValidUntil}
                componentsProps={{
                                actionBar: { actions: ["clear"] },
                              }}
                renderInput={(params) => <TextField
                    InputLabelProps={{}}
                    {...params}
                    fullWidth
                    size="small"
                    inputRef={refDatePicker}
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flex: 1,
                        backgroundColor: theme.palette.background.paper,
                        '& .MuiOutlinedInput-root': {
                            boxSizing: 'border-box',
                            alignItems: 'center',
                        },
                        '& .MuiInputBase-input': {
                            boxSizing: 'border-box',
                            padding: '0 8px',
                        },
                        '& .MuiInputAdornment-root': {
                            margin: 0,
                        },
                        '& .MuiIconButton-root': {
                            padding: '4px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            transition: 'border-color 0.15s ease',
                        },
                    }}
                />}
            />
        </Box>

    );

});

export const DateToEditorComponent = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [validUntil, setValidUntil] = useState(props.value || null);
    const [minDate, setMinDate] = useState(null);
const theme = useTheme();
    const handleValidUntilChange = (newValue) => {
        setValidUntil(newValue);
        const rowData = props.node;
        rowData.setDataValue('validTo', moment(newValue).format('YYYY-MM-DD'))
    };

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (validUntil !== null) {
                    return moment(validUntil).format('YYYY-MM-DD');

                }
            },
            focusIn() {
                var eInput = refDatePicker.current;
                // if (eInput) {
                eInput?.focus();
                eInput?.select();
                // }
            },
            getToDate() {
                return moment(validUntil).format('YYYY-MM-DD');
            },
        };
    });
    useEffect(() => {
        // get ref from React component
        window.setTimeout(() => {
            const eInput = refDatePicker.current;
            eInput?.focus();
        });
        props.api?.getCellEditorInstances().map((editor) => {
            if (editor?.getFromDate) {
                setMinDate(editor.getFromDate());

            }
        })
    }, []);

    const handleFocusValidUntil = () => {
        props.api?.getCellEditorInstances().map((editor) => {
            if (editor?.getFromDate) {
                setMinDate(editor.getFromDate());

            }
        })
    }

    return (

        <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'stretch' }}>
            <CustomDatePicker
                format={'dd-MM-yyyy'}
                name={'validUntil'}
                value={validUntil}
                onOpen={handleFocusValidUntil}
                sx={{ width: '100%', height: '100%', backgroundColor: theme.palette.background.paper }}
                minDate={minDate && new Date(minDate)}
                handleChange={handleValidUntilChange}
                componentsProps={{
                                actionBar: { actions: ["clear"] },
                              }}
                renderInput={(params) => <TextField
                    InputLabelProps={{}}
                    {...params}
                    fullWidth
                    size="small"
                    inputRef={refDatePicker}
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flex: 1,
                        backgroundColor: theme.palette.background.paper,
                        '& .MuiOutlinedInput-root': {
                            boxSizing: 'border-box',
                            alignItems: 'center',
                        },
                        '& .MuiInputBase-input': {
                            boxSizing: 'border-box',
                            padding: '0 8px',
                        },
                        '& .MuiInputAdornment-root': {
                            margin: 0,
                        },
                        '& .MuiIconButton-root': {
                            padding: '4px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            transition: 'border-color 0.15s ease',
                        },
                    }}
                />}
            />
        </Box>

    );

});
